import app from 'app';
import ModalRegion from 'ModalRegion';
import Analytics from 'c/WtAnalytics';
import ProducedPage from 'v/Produced/ProducedPage.vue';
import ProducingPage from '../views/Producing/ProducingPage.vue';
import NotificationFeedback from '../views/NotificationFeedback.vue';
import Dashboard from '../views/Dashboard/Dashboard.vue';
import SiteVersionView from '../views/SiteVersionView.vue';
import Marionette from 'backbone.marionette';
import ModulePopupAction from '#/store/module/popupAction.vuex';
import MastheadStoryBackIcon from 'v/Masthead/MastheadStoryBackIcon.vue';
import MastheadEmbeddedBackIcon from 'v/Masthead/MastheadEmbeddedBackIcon.vue';
import MastheadMenuGeneral from 'v/Masthead/MastheadMenuGeneral.vue';
import MastheadMenuEmbedded from 'v/Masthead/MastheadMenuEmbedded.vue';
// import MastheadSupportIcon from 'v/Masthead/MastheadSupportIcon.vue';
import CloseEmbeddedModal from 'v/Masthead/CloseEmbeddedModal.vue';
import MakeWochitButton from 'v/Masthead/MakeWochitButton.vue';
import GetTheAppButton from 'v/Masthead/GetTheAppButton.vue';
import DashboardNavigation from 'v/Masthead/DashboardNavigation.vue';
import MastheadHomeIcon from 'v/Masthead/HomeIcon.vue';
import MastheadInfoIcon from 'v/Masthead/InfoIcon.vue';
import MastheadTitle from 'v/Masthead/Title.vue';
import PreviewAndProduce from 'v/Masthead/PreviewAndProduce.vue';
import MastheadStoryStyle from 'v/Masthead/MastheadStoryStyle.vue';
import MastheadStoryAspectRatio from 'v/Masthead/MastheadStoryAspectRatio.vue';
import MastheadStoryColorsAndFonts from 'v/Masthead/MastheadStoryColorsAndFonts.vue';
import MastheadOrganizationSelector from 'v/Masthead/MastheadOrganizationSelector.vue';
import Vue from 'vue';
import NotificationView from 'v/NotificationView';
import RouteNotFoundView from 'v/RouteNotFoundView';
import AutosavePanel from 'v/AutosavePanel';

app.namespace.View.AppLayout = Marionette.LayoutView.extend({
  el: 'body',
  eventNamespace: '.AppLayout',
  template: false,

  initialize: function (options) {
    this.bindUIElements();
    this.options = options;
    this.listenTo(app, 'app.clearSearchPanel', this.clearSearchPanel);
    this.listenTo(app, 'app.dimENV', this._dimENV);

    app.keyboardAccessibility.on();
    app.keyboardAccessibility.add(app.KEYBOARD_LAYER.GLOBAL, [
      { on: 'keydown', key: 83 /** S*/, run: this._onPageSave.bind(this) },
    ]);

    $(window).on(
      'resize' + this.eventNamespace,
      this._window_resize.bind(this)
    );

    window.addEventListener('beforeunload', this._window_beforeunload);
    window.addEventListener('unload', this._window_unload);

    if (!app.rootStore.getters['user/box'].isProd()) {
      const vm = new (Vue.extend(SiteVersionView))({
        store: app.rootStore,
      });
      this.$('.js-site-version').append(vm.$mount().$el);
    }

    app.startPageController.getUserStatus().done(function (status) {
      // status = 'EMAIL_NOT_VERIFIED';
      const startDate = app.moment(app.rootStore.state.user['creationTime']);
      const now = app.moment(new Date());
      const expiredPeriodHours =
        tk.context.verificationExpiredPeriodMinutes / 60;
      const expiredDate = app
        .moment(startDate)
        .add(expiredPeriodHours, 'hours');
      const duration = app.moment.duration(expiredDate.diff(now));
      const durationDays = parseInt(duration.asDays()) + 1;

      if (status === 'EMAIL_NOT_VERIFIED' && !app.notificationIsOpened) {
        app.controller.showNotification(
          new NotificationView({
            templateId: 'notification-sign-in-tmpl',
            experatedDays: durationDays,
            isFirstLogin: app.rootStore.getters['user/isFirstLogin'],
          })
        );
        app.notificationIsOpened = true;
      }
    });

    if (app.rootStore.getters['user/isImpededTemplatizer']) {
      app.rootStore.commit('masthead/setTempletiserTabs');

      let isFirstChannelEvent = true;
      // @NOTE - no unsubscribe call cause for lifetime
      app.api.realTime.listenOn({
        path: `/channels/${sessionStorage.getItem('channelId')}/categories`,
        callback: () => {
          if (!isFirstChannelEvent) {
            // console.log('FETCH_STORYBOARD_CATEGORIES', val);
            app.rootStore.dispatch('FETCH_STORYBOARD_CATEGORIES', {
              reset: true,
            });
          } else {
            isFirstChannelEvent = false;
          }
        },
      });
    } else {
      app.api.dashboards.get().always((data) => {
        app.rootStore.commit('setAnalyticsData', data);
        if (404 !== data.status) {
          app.rootStore.commit(
            'masthead/toggleNavigationTab',
            'dashboard/analytics'
          );
        }
      });

      if (
        app.rootStore.getters['user/hasPermission'](app.ROLES.STORY_CREATION)
      ) {
        if (tk.context.organization?.showPrivatePool) {
          app.rootStore.commit(
            'masthead/toggleNavigationTab',
            'dashboard/discover'
          );
        }
      }
    }

    app.rootStore.dispatch('FETCH_STORYBOARD_CATEGORIES');

    const timer = new app.namespace.Util.Timer(() => {
      app.rootStore.commit('setCurrentTime');
      timer.start();
    }, 60 * app.TIME.second());
    timer.start();

    if ($.isElement(this.rFeedback.$el)) {
      this.rFeedback.show(
        new (app.Vue.extend(NotificationFeedback))({
          store: app.rootStore,
        })
      );
    }
    if (!app.isEmbedded) {
      app.notificationController.listen();
    }
  },

  ui: {
    dimElem: '.js-darken-env',
    header: 'header',
    inviteOption: '.js-invite-option',
  },

  regions: {
    rHeader: '.js-region-header',
    rMainView: '.js-region-main',
    rModal: ModalRegion,
    rFeedback: '.js-region-feedback',

    rNotificationBar: '.wt-notification-bar',
    rStoryTopLeft: '.wt-story-top-left',
    rStoryAutosavePanel: '.js-story-autosave-panel',
    rStoryAspectRatio: '.js-story-aspect-ratio',
    rStoryColorsAndFonts: '.js-story-colors-and-fonts',
    rOrganizationSelector: '.js-organization-selector',
    rStoryStyle: '.js-story-style',
    collageSupportLink: '.js-learn-more-collages',
    rTitle: '.wt-header-title',
    rActions: '.js-region-actions',
    rSanta: '.js-region-santa',
    rDashboardNavigation: '.js-region-dashboard-navigation',
    rMenu: '.js-region-menu',
    rEditInfo: '.wt-region-edit-info',
    rCloseModal: '.js-region-close-modal',
  },

  events: {
    /**
     *  dispatch navigate events from DOM to global events pipe
     */
    'click [data-navigate]:not([disabled])': _.debounce(
      function (e) {
        e.preventDefault();
        const $el = $(e.currentTarget);
        if ($el.data('navigate') === 'start') {
          if ($el.hasClass('js-btn-start')) {
            Analytics.trigger('analytics:dashboard:newVideo', {
              Location: 'Left Dashboard Panel',
            });
          } else if ($el.hasClass('js-create-new-in-publish')) {
            Analytics.trigger(
              'analytics:publishScreen:clickedCreateNewFromHeader',
              {
                Source: 'Publish Page',
              }
            );
          } else {
            Analytics.trigger('analytics:dashboard:newVideo', {
              Location: 'Header Dashboard',
            });
          }
        } else if ($el.hasClass('js-back-dashboard-in-publish')) {
          Analytics.trigger(
            'analytics:publishScreen:clickedDashboardFromHeader',
            {
              Source: 'Publish Page',
            }
          );
        }

        app.navigate($el.data('navigate'));
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),

    'click @ui.dimElem': '_dimENV',

    /**
     * Hide context-menu on proprietary media containers due media-providers request
     * to harden user access to the source download functionality
     * @note: hide on prod/test, but not on dev
     */
    'contextmenu video, img, canvas': function (e) {
      if (!app.rootStore.getters['user/box'].isDev()) {
        e.preventDefault();
        return false;
      }
    },
  },

  showModal: function (view) {
    this.rModal.show(view);
  },

  hideModal: function () {
    this.rModal.empty();
  },

  changeMasthead: function (classes) {
    const $el = this.rHeader.$el;

    $el.removeClass();

    $el.addClass(`js-region-header ${classes}`);
  },

  showRouteNotFound: function () {
    this.regionManager.each((r) => {
      r.empty();
    });
    this.rMainView.show(new RouteNotFoundView({}));
  },

  showDashboard: function (options) {
    this.changeMasthead('wt2-masthead-dashboard');

    this.rDashboardNavigation.show(
      new (app.Vue.extend(DashboardNavigation))({
        store: app.rootStore,
      }),
      {
        preventDestroy: true,
      }
    );
    this.rStoryTopLeft.show(new MastheadHomeIcon({ store: app.rootStore }));
    this.rOrganizationSelector.show(
      new MastheadOrganizationSelector({ store: app.rootStore })
    );
    this.rStoryAutosavePanel.empty();
    this.rStoryAspectRatio.empty();
    this.rStoryColorsAndFonts.empty();
    this.rStoryStyle.empty();
    this.collageSupportLink.empty();
    this.rTitle.empty();
    this.rEditInfo.empty();
    // show button, only if user has permission to create story
    if (app.rootStore.getters['user/hasPermission'](app.ROLES.STORY_CREATION)) {
      this.rActions.show(
        new (app.Vue.extend(MakeWochitButton))({
          store: app.rootStore,
        })
      );
    } else {
      this.rActions.empty();
    }

    // "Get the Wochit App" promo pill, shown to all dashboard users just left
    // of the "Make a Wochit" button.
    this.rSanta.show(
      new (app.Vue.extend(GetTheAppButton))({
        store: app.rootStore,
      })
    );

    this.rMainView.show(
      new Dashboard({
        store: app.rootStore,
        data: {
          categoryId: options.categoryId,
          q: options.q,
        },
      })
    );

    if (app.rootStore.getters['user/isImpededTemplatizer']) {
      this.rMenu.empty();
    } else {
      this.rMenu.show(
        new MastheadMenuGeneral({
          store: app.rootStore,
        })
      );
    }

    this.rCloseModal.empty();
  },

  showStory: function (storyModel, storyController) {
    this.changeMasthead('wt2-masthead-light wt2-masthead-story');

    const previewAndProduce = new (app.Vue.extend(PreviewAndProduce))({
      store: app.rootStore,
      propsData: {
        onClick: storyController.previewStory.bind(storyController),
      },
    });
    this.rActions.show(previewAndProduce);

    this.rMainView.show(storyController.storyView);
    this.rEditInfo.show(storyController.storyMetadataView);

    this.$el.find('.js-story-id-caption').hide();

    if (app.isEmbedded) {
      this.rStoryTopLeft.show(new MastheadEmbeddedBackIcon());
    } else {
      this.rStoryTopLeft.show(new MastheadStoryBackIcon());
    }

    this.rDashboardNavigation.empty({ preventDestroy: true });

    this.collageSupportLink.empty();
    this.rOrganizationSelector.empty();
    this.rSanta.empty();
    this.rStoryAutosavePanel.show(
      new AutosavePanel({
        model: storyModel,
        controller: storyController,
      })
    );
    this.rStoryAspectRatio.show(
      new MastheadStoryAspectRatio({
        store: app.rootStore,
        propsData: {},
      })
    );

    if (app.rootStore.getters.showStyleEditor) {
      this.rStoryColorsAndFonts.show(
        new MastheadStoryColorsAndFonts({
          store: app.rootStore,
          propsData: {},
        })
      );
    }

    this.rStoryStyle.show(
      new MastheadStoryStyle({
        store: app.rootStore,
        propsData: {},
      })
    );

    const mastheadTitle = new (app.Vue.extend(MastheadTitle))({
      store: app.rootStore,
      propsData: {
        object: storyModel.pick(['title']),
        editable: true,
      },
    });
    // wire mastheadTitle with model
    mastheadTitle.$on('change', (e) => {
      storyModel.set('title', e.target.value);
    });
    // wire model with mastheadTitle
    storyModel.on('change:title', (model, newTitle) => {
      mastheadTitle.object.title = newTitle;
    });

    this.rTitle.show(mastheadTitle);

    const mastheadMenu = new (
      app.isEmbedded ? MastheadMenuEmbedded : MastheadMenuGeneral
    )({
      store: app.rootStore,
      propsData: {
        context: 'story',
        showExpandCollapse: false,
      },
    });
    this.rMenu.show(mastheadMenu);

    if (app.isEmbedded) {
      this.rCloseModal.show(new CloseEmbeddedModal());
    } else {
      this.rCloseModal.empty();
    }
  },

  showVideoProducing: function (videoModel) {
    this.changeMasthead('wt2-masthead-light wt2-masthead-producing-page');
    const store = new app.Vuex.Store(ModulePopupAction);

    const mastheadTitle = new (app.Vue.extend(MastheadTitle))({
      store: app.rootStore,
      propsData: {
        object: videoModel.pick(['title', 'template']),
        editable: false,
      },
    });

    const infoIcon = new (app.Vue.extend(MastheadInfoIcon))({
      store: store,
    });

    const videoView = new (app.Vue.extend(ProducingPage))({
      propsData: {
        video: videoModel.toJSON(),
      },
      store: store,
    });

    this.rEditInfo.empty();
    this.rMainView.show(videoView);
    this.rStoryTopLeft.show(
      new (app.Vue.extend(MastheadHomeIcon))({
        store: app.rootStore,
      })
    );
    this.rTitle.show(mastheadTitle);
    this.rActions.show(infoIcon);

    this.rDashboardNavigation.empty({ preventDestroy: true });
    this.rOrganizationSelector.empty();
    this.rSanta.empty();
    this.rStoryAutosavePanel.empty();
    this.rStoryAspectRatio.empty();
    this.rStoryColorsAndFonts.empty();
    this.rStoryStyle.empty();
    this.collageSupportLink.empty();

    if (app.rootStore.getters['user/isImpededTemplatizer']) {
      this.rMenu.empty();
    } else {
      this.rMenu.show(
        new MastheadMenuGeneral({
          store: app.rootStore,
        })
      );
    }

    this.rCloseModal.empty();
  },

  showVideo: function (producedStory) {
    this.changeMasthead('wt2-masthead-light wt2-masthead-produced-page');
    const store = new app.Vuex.Store(ModulePopupAction);
    const rHeaderEl = this.rHeader.$el;

    const mastheadTitle = new (app.Vue.extend(MastheadTitle))({
      store: app.rootStore,
      propsData: {
        object: _.pick(producedStory, ['title', 'template']),
        editable: false,
      },
    });

    const videoView = new ProducedPage({
      propsData: {
        video: producedStory,
      },
      store: store,

      onToggleMasthead(status) {
        rHeaderEl
          .removeClass('wt2-hide-masthead')
          .addClass(status ? '' : 'wt2-hide-masthead');
      },
    });

    const infoIcon = new Vue({
      store,
      render(h) {
        const children = [h(MastheadInfoIcon)];
        return h(
          'div',
          {
            class: '-info-actions wt2-sg',
          },
          children
        );
      },
    });

    this.rEditInfo.empty();
    this.rMainView.show(videoView);
    this.rStoryTopLeft.show(
      new (app.Vue.extend(MastheadHomeIcon))({
        store: app.rootStore,
      })
    );
    this.rTitle.show(mastheadTitle);
    this.rActions.show(infoIcon);

    this.rDashboardNavigation.empty({ preventDestroy: true });
    this.rStoryAutosavePanel.empty();
    this.rOrganizationSelector.empty();
    this.rSanta.empty();
    this.rStoryAspectRatio.empty();
    this.rStoryColorsAndFonts.empty();
    this.rStoryStyle.empty();
    this.collageSupportLink.empty();

    if (app.rootStore.getters['user/isImpededTemplatizer']) {
      this.rMenu.empty();
    } else {
      this.rMenu.show(
        new MastheadMenuGeneral({
          store: app.rootStore,
        })
      );
    }

    this.rCloseModal.empty();
  },

  clearSearchPanel: function () {
    this.rTitle.empty();
  },

  _onPageSave: function (e) {
    if (e.ctrlKey || e.metaKey) {
      // deny page save
      e.preventDefault();
    }
  },

  _window_beforeunload: function (e) {
    const story = app.storyController.story;
    let storyChanged = false;
    if (story) {
      storyChanged = story.modelState.get('isDirty');
      app.broadcast.emit('sw-story-exit', { storyId: story.id });
    }

    // confirm leave current page if logged in and story changed
    if (
      app.state.isNavigationBlocked() &&
      !app.rootStore.getters['user/box'].isDev() &&
      storyChanged
    ) {
      // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload#Example
      e.preventDefault();
      e.returnValue = '';
    }
  },

  _window_unload: function (e) {
    app.broadcast.emit('sw-window-unload');
  },

  _window_resize: function () {
    // adjust height of scrollable
    const $scrollables = $('.wt-scrollable');
    let $scrollable;
    let $siblings;
    let $sibling;
    let siblingsHeight;
    let newHeight;

    $scrollables.each(function (i, scrollable) {
      $scrollable = $(scrollable);
      $siblings = $($scrollable.data('other-elements'));
      siblingsHeight = _.reduce(
        $siblings,
        function (accumulator, sibling) {
          $sibling = $(sibling);
          return accumulator + $sibling.outerHeight(true);
        },
        0
      );

      newHeight = $(window).height() - siblingsHeight;
      $scrollable.height(newHeight);
    });
  },

  onDestroy: function () {
    $(window).off(this.eventNamespace);
    $(document).off(this.eventNamespace);
    window.removeEventListener('beforeunload', this._window_beforeunload);
  },

  _dimENV: function (options) {
    if (options.show) {
      this.ui.dimElem.fadeIn('fast');
    } else {
      this.ui.dimElem.fadeOut('fast');
    }
  },
});

export default app.namespace.View.AppLayout;
